import { blogData, blogDataListDTO } from "../model/BlogData";
import { socialNetworkService } from "../appConfig/AxiosConfig";

const createBlog = async (title: string, description: string, metaTitle: string, metaDescription: string, content: string, displayPic: File) => {

    var form = new FormData();
    form.append("title", title);
    form.append("description", description);
    form.append("content", content);
    form.append("file", displayPic);
    return await (await socialNetworkService.post(`/v2/blogs/create`, form)).data;
}

const updateBlog = async (blogId: string, title: string, description: string, metaTitle: string, metaDescription: string, content: string, displayPic: File) => {

    var form = new FormData();
    form.append("title", title);
    form.append("description", description);
    form.append("metaTitle", metaTitle);
    form.append("metaDescription", metaDescription);
    form.append("content", content);
    form.append("file", displayPic);
    return await (await socialNetworkService.post(`/v2/blogs/update/${blogId}`, form)).data;
}

const getBlogs = async (page: number) => {
    let response = await socialNetworkService.get<blogData[]>(`/v2/blogs/all?pagesize=10&page=${page}`);
    return response.data;
}

const getBlogsWithCount = async (page: number, pageSize: number, getCount: boolean) => {
    let response = await socialNetworkService.get<blogDataListDTO>(`/v2/blogs/allwithcount?pagesize=${pageSize}&page=${page}&count=${getCount}`);
    return response.data;
}

const getBlog = async (id: number) => {
    let response = await socialNetworkService.get(`/blogs/${id}`);
    return response.data;
}

const getPublishedBlogs = async (page: number) => {
    let response = await socialNetworkService.get<blogData[]>(`/v2/blogs/published?pagesize=10&page=${page}`);
    return response.data;
}

const uploadBlogImage = async (file: File) => {
    var formdata = new FormData();
    formdata.append("file", file);
    return await (await socialNetworkService.post(`/v2/blogs/files/upload`, formdata)).data;
}

const getBlogsByName = async (name: string) => {
    return await (await socialNetworkService.get<blogData[]>(`/v2/blogs/name/${name}`)).data;
}

const publishBlog = async (id: string) => {
    return (await socialNetworkService.post<blogData>(`/v2/blogs/publish/${id}`)).data;
}

const deleteBlog = async (id: string) => {
    let response = await socialNetworkService.delete(`/blogs/${id}`);
    return response.data;
}



export { getBlogs, getBlogsWithCount, getBlog, deleteBlog, createBlog, updateBlog, getBlogsByName, getPublishedBlogs, uploadBlogImage, publishBlog }